module.exports = __webpack_public_path__ + "img/3.bca7a3d6.jpg";